import { render } from "./vcurriculumlistadd.vue?vue&type=template&id=0aee7928&scoped=true"
import script from "./vcurriculumlistadd.vue?vue&type=script&lang=js"
export * from "./vcurriculumlistadd.vue?vue&type=script&lang=js"

import "./vcurriculumlistadd.vue?vue&type=style&index=0&id=0aee7928&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境租户后台rent.syinba.com/jsvueweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0aee7928"]])

export default __exports__